import Phaser from 'phaser';

import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { CardViewModel } from './card-view-model';

export class CardShadowView extends Phaser.GameObjects.Container {
  private viewModel: CardViewModel;
  private cardShadow: Phaser.GameObjects.Image;

  private shadowAlpha = 0;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: CardViewModel) {
    super(scene, x, y);

    this.viewModel = viewModel;

    this.cardShadow = scene.add.image(0, 0, viewModel.cardShadowAsset.type).setOrigin(0.5, 0.5);

    this.add([this.cardShadow]);
    this.setName(CardShadowView.name);
    scene.add.existing(this);
  }

  public refreshInterface(delta: number) {
    this.viewModel.refreshShadow();
    this.animateShadow(delta);
  }

  public onResize(scaleFactor: number): void {
    this.resizeCardShadow(scaleFactor);
  }

  private resizeCardShadow(scaleFactor: number) {
    const asset = this.viewModel.cardShadowAsset;
    this.cardShadow.setDisplaySize(
      asset.dimensions.width * scaleFactor,
      asset.dimensions.height * scaleFactor,
    );
  }

  private animateShadow(delta: number) {
    const multiplier = this.viewModel.canShowShadow ? 0.0025 : -0.0025;
    this.shadowAlpha = Phaser.Math.Clamp(this.shadowAlpha + delta * multiplier, 0, 1);
    this.cardShadow.alpha = this.shadowAlpha;
  }
}
